"use client";

import { memo } from "react";
import type { StockListingUILabels } from "../../../interfaces/StockListingTableAEM.interface";
import { useStockListingFilters } from "../context/StockListingFiltersContext";
import StockActiveFilterChips from "./StockActiveFilterChips";
import StockSortChip from "./StockSortChip";
import type { SortOption } from "./StockSortDropdown";

export interface StockHeaderBarMobileDynamicContentProps {
  uiLabels?: StockListingUILabels;
  initialHasActiveFilters?: boolean;
  hideActiveFilterChips?: boolean;
  sortValue: string;
  sortOptions: SortOption[];
  showSelectedSortChip?: boolean;
  sortChipSectionTitle?: string;
}

const StockHeaderBarMobileDynamicContent = memo(
  ({
    uiLabels = {},
    initialHasActiveFilters = false,
    hideActiveFilterChips = false,
    sortValue,
    sortOptions,
    showSelectedSortChip = false,
    sortChipSectionTitle,
  }: StockHeaderBarMobileDynamicContentProps) => {
    const { activeFilters, activeSortValue } = useStockListingFilters();
    const currentSortValue = activeSortValue ?? sortValue;
    const defaultSortValue = sortOptions[0]?.value;
    const selectedSortOption = sortOptions.find(
      (option) => option.value === currentSortValue,
    );

    if (
      showSelectedSortChip &&
      selectedSortOption &&
      currentSortValue !== defaultSortValue
    ) {
      return (
        <div className="absolute inset-0 bg-white">
          <StockSortChip
            label={selectedSortOption.label}
            resetSortValue={defaultSortValue}
            sortCtAnalytics={
              sortChipSectionTitle
                ? { sectionTitle: sortChipSectionTitle }
                : undefined
            }
            clearCtaText={uiLabels.clearAllFiltersText ?? "Clear Filters"}
          />
        </div>
      );
    }

    if (hideActiveFilterChips) {
      return null;
    }

    const hasActiveFilters =
      (activeFilters?.index?.length ?? 0) > 0 ||
      (activeFilters?.sector?.length ?? 0) > 0 ||
      (activeFilters?.mktcap?.length ?? 0) > 0 ||
      (activeFilters?.alphabetic?.length ?? 0) > 0;

    if (!hasActiveFilters) {
      return null;
    }

    return (
      <div
        className={
          initialHasActiveFilters
            ? "p-4 md:px-0 w-79 md:w-unset"
            : "absolute inset-0 bg-white p-4 md:px-0"
        }
      >
        <StockActiveFilterChips uiLabels={uiLabels} mode="mobileHeader" />
      </div>
    );
  },
);

StockHeaderBarMobileDynamicContent.displayName = "StockHeaderBarMobileDynamicContent";

export default StockHeaderBarMobileDynamicContent;